import PropTypes from 'prop-types'

export const PRODUCT_PLAN_TYPE = PropTypes.shape({
  id: PropTypes.number,
  price: PropTypes.string,
  pricing: PropTypes.object,
})
